/**
 * Created by Daniel Wang on 1/18/2024.
 * Description: the effects for admin shard page
 * ------ maintenance history ------
 */
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { switchMap, map, catchError, mergeMap } from 'rxjs/operators';
import { AdminPagesService } from '../../../tamalelibs/services/admin-page.service';
import { AdminPageActionTypes } from '../../actions/admin-page.actions';

@Injectable()
export class AdminSharedPageEffects {
    constructor(
        private _actions$: Actions,
        private _adminPageService: AdminPagesService
    ) { }

    getSharedPageEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(AdminPageActionTypes.GET_SHARED_PAGE),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => {
            return this._adminPageService.getData(payload.type).pipe(
                map(response => {
                    if (!Array.isArray(response)) {
                        if (JSON.stringify(response) === '{}') {
                            response = [];
                        } else {
                            response = [response];
                        }
                    }
                    let dataList = response.map(element => {
                        return this._adminPageService.getParseData(element, payload.type);
                    });
                    dataList = this._adminPageService.updateData(payload.type, dataList);
                    return {
                        type: AdminPageActionTypes.GET_SHARED_PAGE_SUCCESS,
                        payload: dataList
                    };
                })
            );
        }),
        catchError(err => {
            return of({
                type: AdminPageActionTypes.GET_SHARED_PAGE_FAILURE,
                payload: err.message
            });
        })
    ));

    createSharedPageEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(AdminPageActionTypes.CREATE_SHARED_PAGE),
        map((action: any) => action.payload),
        switchMap((payload) => {
            return this._adminPageService.createData(payload.type, payload.key, payload.item).pipe(
                map(response => {
                    const data = this._adminPageService.getParseData(response, payload.type);
                    return {
                        type: AdminPageActionTypes.CREATE_SHARED_PAGE_SUCCESS,
                        payload: {
                            type: payload.type,
                            data: data
                        }
                    };
                })
            );
        }),
        catchError(err => {
            return of({
                type: AdminPageActionTypes.CREATE_SHARED_PAGE_FAILURE,
                payload: err.message
            });
        })
    ));

    editSharedPageEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(AdminPageActionTypes.EDIT_SHARED_PAGE),
        map((action: any) => action.payload),
        switchMap((payload) => {
            return this._adminPageService.editData(payload.type, payload.key, payload.item).pipe(
                map(response => {
                    const data = this._adminPageService.getParseData(response, payload.type);
                    return {
                        type: AdminPageActionTypes.EDIT_SHARED_PAGE_SUCCESS,
                        payload: data
                    };
                })
            );
        }),
        catchError(err => {
            return of({
                type: AdminPageActionTypes.EDIT_SHARED_PAGE_FAILURE,
                payload: err.message
            });
        })
    ));

    deleteSharedPageEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(AdminPageActionTypes.DELETE_SHARED_PAGE),
        map((action: any) => action.payload),
        switchMap((payload) => {
            return this._adminPageService.deleteData(payload.type, payload.id).pipe(
                map(() => {
                    return {
                        type: AdminPageActionTypes.DELETE_SHARED_PAGE_SUCCESS,
                        payload: {
                            id: payload.id,
                            name: payload.name
                        }
                    };
                }),
                catchError(err => {
                    return of({
                        type: AdminPageActionTypes.DELETE_SHARED_PAGE_FAILURE,
                        payload: err.message
                    });
                })
            );
        })
    ));
}
